import React, { useState } from "react";

import CSSModules from "react-css-modules";
import css from "./styles.scss";

import { Div, Text3, SmallCheckbox, BigFilledButton } from "components/Base";
import { Link } from "react-router";

import { noop } from "utils/General";

import Tooltip from "components/Global/Tooltip";

const TermsCondModal = ({
  termsAccepted = false,
  continueToDashboard = noop
}) => {
  const [checked, setchecked] = useState(termsAccepted);
  const checkbox = (
    <SmallCheckbox
      title={undefined}
      size={20}
      selected={checked}
      onClick={() => {
        setchecked(!checked);
      }}
      selectedColor={"#00CC83"}
    />
  );
  return (
    <div>
      <div className="modal-header">
        <div className="modal-title">Almost there...</div>
        <div className="modal-description">
          One last step before you can start using Sessionboard.
        </div>
      </div>
      <div className="modal-body">
        <div className="modal-body-wrapper">
          <div className="input-wrapper">
            <Div display="column.center.flex-start" style={{ gap: 20 }}>
              <Div display="row.center.flex-start">
                {!checked && (
                  <Tooltip tooltip="Please confirm you agree to our policies.">
                    {checkbox}
                  </Tooltip>
                )}
                {checked && checkbox}
                <Div ml={1}>
                  <Text3 color="neutral7">I agree to Sessionboard's </Text3>
                  <Link
                    to={{
                      pathname:
                        "https://www.sessionboard.com/legal/terms-of-service"
                    }}
                    target="_blank"
                    style={{ color: "#5CC989", fontWeight: "600" }}
                  >
                    Terms of Service
                  </Link>{" "}
                  and{" "}
                  <Link
                    to={{
                      pathname:
                        "https://www.sessionboard.com/legal/privacy-policy"
                    }}
                    target="_blank"
                    style={{ color: "#5CC989", fontWeight: "600" }}
                  >
                    Privacy Policy
                  </Link>{" "}
                </Div>
              </Div>
              <BigFilledButton
                bg="#00CC83"
                color="white"
                disabled={!checked}
                onClick={() => {
                  continueToDashboard(checked);
                }}
                width={1}
                style={{ borderRadius: "16px" }}
              >
                CONTINUE
              </BigFilledButton>
            </Div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CSSModules(TermsCondModal, css);
